import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { retweetsConfig } from '../retweets';

export const mediaViewerRetweetsSimpleConfig: StatsConfig = {
    ...retweetsConfig,
    id: 'retweet_count', // Override to match API field name
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
